export default function initBreadcrumbs() {

    const breadCrumbs = document.querySelectorAll('.bread-crumbs');
    if (!breadCrumbs.length) return;

    [...breadCrumbs].forEach(elem => {

        const breadCrumbsItems = elem.querySelectorAll('.bread-crumbs__item');
        if (!breadCrumbsItems.length) return;

        const outerContainerWidth = elem.parentElement.offsetWidth - 20;
        if (!outerContainerWidth) return;

        const itemsWidth = [];
        [...breadCrumbsItems].forEach(item => {
            itemsWidth.push(item.offsetWidth);
        });
        const itemsWidthSum = itemsWidth.reduce((partialSum, a) => partialSum + a, 0);

        if (itemsWidthSum > outerContainerWidth) {
            elem.classList.add('bread-crumbs__scope');
        }
    });
}
